import { t } from "../i18n";

export default (store) => {
  const updatePagetitle = (isPublic) =>
    (document.title = t(isPublic ? "app.titlePublic" : "app.titleGrimoire"));

  // initialize data
  if (localStorage.getItem("background")) {
    store.commit("setBackground", localStorage.background);
  }
  if (localStorage.getItem("muted")) {
    store.commit("toggleMuted", true);
  }
  if (localStorage.getItem("static")) {
    store.commit("toggleStatic", true);
  }
  if (localStorage.getItem("statusEffects") === "0") {
    store.commit("toggleStatusEffects", false);
  }
  if (localStorage.getItem("roleDrawEnabled") === "1") {
    store.commit("toggleRoleDraw", true);
  }
  if (localStorage.getItem("roleDrawOptions")) {
    store.commit(
      "roleDraw/setOptions",
      JSON.parse(localStorage.getItem("roleDrawOptions")),
    );
  }
  if (localStorage.getItem("imageOptIn") === "0") {
    store.commit("toggleImageOptIn", false);
  }
  if (localStorage.getItem("imageOptIn") === "1") {
    store.commit("toggleImageOptIn", true);
  }
  if (localStorage.getItem("zoom")) {
    store.commit("setZoom", parseFloat(localStorage.getItem("zoom")));
  }
  if (localStorage.getItem("publicView") === "1") {
    store.commit("toggleGrimoire", true);
    updatePagetitle(true);
  } else if (localStorage.getItem("publicView") === "0") {
    store.commit("toggleGrimoire", false);
    updatePagetitle(false);
  }
  if (localStorage.roles !== undefined) {
    store.commit("setCustomRoles", JSON.parse(localStorage.roles));
    store.commit("setEdition", { id: "custom" });
  }
  if (localStorage.edition !== undefined) {
    // this will initialize state.roles for official editions
    store.commit("setEdition", JSON.parse(localStorage.edition));
  }
  if (localStorage.bluffs !== undefined) {
    JSON.parse(localStorage.bluffs).forEach((role, index) => {
      store.commit("players/setBluff", {
        index,
        role: store.state.roles.get(role) || {},
      });
    });
  }
  if (localStorage.lunaticBluffs !== undefined) {
    JSON.parse(localStorage.lunaticBluffs).forEach((role, index) => {
      store.commit("players/setLunaticBluff", {
        index,
        role: store.state.roles.get(role) || {},
      });
    });
  }
  if (localStorage.fabled !== undefined) {
    store.commit("players/setFabled", {
      fabled: JSON.parse(localStorage.fabled).map(
        (fabled) => store.state.fabled.get(fabled.id) || fabled,
      ),
    });
  }
  if (localStorage.players) {
    store.commit(
      "players/set",
      JSON.parse(localStorage.players).map((player) => ({
        ...player,
        role:
          store.state.roles.get(player.role) ||
          store.getters.rolesJSONbyId.get(player.role) ||
          {},
      })),
    );
  }
  /**** Session related data *****/
  if (localStorage.getItem("playerId")) {
    store.commit("session/setPlayerId", localStorage.getItem("playerId"));
  }
  if (localStorage.getItem("playerName")) {
    store.commit("session/setPlayerName", localStorage.getItem("playerName"));
  }
  if (localStorage.getItem("session") && !window.location.hash.substr(1)) {
    const [spectator, sessionId] = JSON.parse(localStorage.getItem("session"));
    store.commit("session/setSpectator", spectator);
    store.commit("session/setSessionId", sessionId);
  }
  if (localStorage.getItem("gameStartedAt")) {
    store.commit(
      "session/setGameStartedAt",
      Number(localStorage.getItem("gameStartedAt")) || Date.now(),
    );
  }
  if (localStorage.getItem("voiceTalkMode")) {
    store.commit("voice/setTalkMode", localStorage.getItem("voiceTalkMode"));
  }
  if (localStorage.getItem("voiceListenVolume")) {
    store.commit(
      "voice/setListenVolume",
      Number(localStorage.getItem("voiceListenVolume")),
    );
  }

  // listen to mutations
  store.subscribe(({ type, payload }, state) => {
    switch (type) {
      case "toggleGrimoire":
        if (state.grimoire.isPublic) {
          localStorage.setItem("publicView", 1);
        } else {
          localStorage.setItem("publicView", 0);
        }
        updatePagetitle(state.grimoire.isPublic);
        break;
      case "setBackground":
        if (payload) {
          localStorage.setItem("background", payload);
        } else {
          localStorage.removeItem("background");
        }
        break;
      case "toggleMuted":
        if (state.grimoire.isMuted) {
          localStorage.setItem("muted", 1);
        } else {
          localStorage.removeItem("muted");
        }
        break;
      case "toggleStatic":
        if (state.grimoire.isStatic) {
          localStorage.setItem("static", 1);
        } else {
          localStorage.removeItem("static");
        }
        break;
      case "toggleStatusEffects":
        localStorage.setItem(
          "statusEffects",
          state.grimoire.statusEffectsEnabled ? "1" : "0",
        );
        break;
      case "toggleRoleDraw":
        localStorage.setItem(
          "roleDrawEnabled",
          state.grimoire.roleDrawEnabled ? "1" : "0",
        );
        break;
      case "roleDraw/setOptions":
        localStorage.setItem(
          "roleDrawOptions",
          JSON.stringify(state.roleDraw.options),
        );
        break;
      case "toggleImageOptIn":
        if (state.grimoire.isImageOptIn) {
          localStorage.setItem("imageOptIn", 1);
        } else {
          localStorage.setItem("imageOptIn", 0);
        }
        break;
      case "setZoom":
        if (payload !== 0) {
          localStorage.setItem("zoom", payload);
        } else {
          localStorage.removeItem("zoom");
        }
        break;
      case "setEdition":
        localStorage.setItem("edition", JSON.stringify(payload));
        if (state.edition.isOfficial) {
          localStorage.removeItem("roles");
        }
        break;
      case "setCustomRoles":
        if (!payload.length) {
          localStorage.removeItem("roles");
        } else {
          localStorage.setItem("roles", JSON.stringify(payload));
        }
        break;
      case "players/setBluff":
        localStorage.setItem(
          "bluffs",
          JSON.stringify(state.players.bluffs.map(({ id }) => id)),
        );
        break;
      case "players/setLunaticBluff":
        localStorage.setItem(
          "lunaticBluffs",
          JSON.stringify(state.players.lunaticBluffs.map(({ id }) => id)),
        );
        break;
      case "players/setFabled":
        localStorage.setItem(
          "fabled",
          JSON.stringify(
            state.players.fabled.map((fabled) =>
              fabled.isCustom ? fabled : { id: fabled.id },
            ),
          ),
        );
        break;
      case "players/add":
      case "players/addMany":
      case "players/setCount":
      case "players/resetSeats":
      case "players/update":
      case "players/remove":
      case "players/clear":
      case "players/set":
      case "players/swap":
      case "players/move":
        if (state.players.players.length) {
          localStorage.setItem(
            "players",
            JSON.stringify(
              state.players.players.map((player) => ({
                ...player,
                // simplify the stored data
                role: player.role.id || {},
              })),
            ),
          );
        } else {
          localStorage.removeItem("players");
        }
        break;
      case "session/setSessionId":
        if (payload) {
          localStorage.setItem(
            "session",
            JSON.stringify([state.session.isSpectator, payload]),
          );
        } else {
          localStorage.removeItem("session");
        }
        break;
      case "session/setGameStartedAt":
        localStorage.setItem("gameStartedAt", payload || Date.now());
        break;
      case "session/setPlayerId":
        if (payload) {
          localStorage.setItem("playerId", payload);
        } else {
          localStorage.removeItem("playerId");
        }
        break;
      case "session/setPlayerName":
        if (payload) {
          localStorage.setItem("playerName", payload);
        } else {
          localStorage.removeItem("playerName");
        }
        break;
      case "voice/setTalkMode":
        localStorage.setItem("voiceTalkMode", state.voice.talkMode);
        break;
      case "voice/setListenVolume":
        localStorage.setItem("voiceListenVolume", state.voice.listenVolume);
        break;
    }
  });
};
